<template>
  <div class="container-fluid px-4 mt-4">
    <!-- Bütün sayfayı kaplayan loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <div class="row" v-show="!loading">
      <div class="container">
        <vue-good-table
            mode="remote"
            @on-column-filter="onColumnFilter($event.columnFilters)"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            :rows="rows"
            :columns="columns"
            :totalRows="totalRecords"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              perPage: serverParams.perPage,
              perPageDropdown: [5, 10, 20, 50],
              dropdownAllowAll: false,
              mode: 'records',
              nextLabel: 'Sonraki',
              prevLabel: 'Önceki',
              rowsPerPageLabel: 'Sayfa başına satır',
              ofLabel: '/',
              pageLabel: 'sayfa',
              allLabel: 'Tümü'
            }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'actions'">
              <b-button
                  variant="success"
                  @click.prevent="downloadReceipt(props.formattedRow)"
              >
                  PDF İndir
                </b-button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentService from '../../service/PaymentService';
import html2pdf from 'html2pdf.js';

export default {
  name: 'client-order-list',
  data() {
    return {
      rows: [],
      columns: [
        { label: 'Sipariş Zamanı', field: 'date', sortable: false },
        { label: 'Firma Ünvanı', field: 'clientName', sortable: false, hidden: true },
        { label: 'İsim Soyisim', field: 'cardName', sortable: false },
        { label: 'Kart Numarası', field: 'cardNumber', sortable: false, hidden: true },
        { label: 'Sipariş Tutarı', field: 'amount', sortable: false },
        { label: 'Detaylar', field: 'actions', sortable: false }
      ],
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
    };
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadReceipts(this.serverParams);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadReceipts(this.serverParams);
    },

    onColumnFilter(params) {
      this.updateParams({ columnFilters: params });
      this.loadReceipts(this.serverParams);
    },

    async loadReceipts() {
      this.loading = true;
      try {
        this.serverParams.clientId = this.$store.state.clientId;
        const response = await PaymentService.getReceiptList(this.serverParams);
        this.rows = response.data;
        this.totalRecords = response.total;
      } catch (error) {
        console.error("Dekont geçmişi görüntülenirken hata oluştu:", error);
        this.$errorNotification(this, "Dekont geçmişi görüntülenirken hata oluştu.");
      } finally {
        this.loading = false;
      }
    },
    async downloadReceipt(row) {
      const logoBase64 = await this.getBase64(require('@/assets/images/NavbarImages/logo-mamas.png'));

      const receipt = document.createElement('div');
      receipt.style.fontFamily = 'Arial, sans-serif';
      receipt.style.fontSize = '12px';
      receipt.style.color = '#333';

      receipt.innerHTML = `
    <!-- Üst Kısım -->
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
      <img src="${logoBase64}" style="height: 50px;" />
      <h2 style="margin: 0 auto; text-align: center; font-size: 20px; color: #5D1F1F;">Ödeme Makbuzu</h2>
      <img src="${logoBase64}" style="height: 50px;" />
      <div style="width: 50px;"></div>
    </div>

    <!-- Bilgi Tablosu -->
    <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
      <tr style="background-color: rgba(246, 180, 0, 0.15);">
        <td style="padding: 8px;"><strong>İşlem Tarihi</strong></td>
        <td style="padding: 8px;">${row.date || '-'}</td>
      </tr>
      <tr>
        <td style="padding: 8px;"><strong>Firma Ünvanı</strong></td>
        <td style="padding: 8px;">${row.clientName || '-'}</td>
      </tr>
      <tr style="background-color: rgba(246, 180, 0, 0.15);">
        <td style="padding: 8px;"><strong>Ad Soyad</strong></td>
        <td style="padding: 8px;">${row.cardName || '-'}</td>
      </tr>
      <tr>
        <td style="padding: 8px;"><strong>İşlem Tutarı</strong></td>
        <td style="padding: 8px;">${row.amount}</td>
      </tr>
      <tr style="background-color: rgba(246, 180, 0, 0.15);">
        <td style="padding: 8px;"><strong>Kart Numarası</strong></td>
        <td style="padding: 8px;">${row.cardNumber}</td>
      </tr>
    </table>

    <!-- Alt Şirket Bilgisi -->
    <p style="font-size: 10px; margin-top: 40px; color: #B82E5D;">
      Validem Unlu Mam. Gıda Tic. Ltd. Şti<br />
    </p>
  `;

      html2pdf()
          .set({
            margin: 10,
            filename: `dekont-${new Date().toISOString().split('T')[0]}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
          })
          .from(receipt)
          .save();
    },

    getBase64(filePath) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        fetch(filePath)
            .then(res => res.blob())
            .then(blob => {
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });
      });
    }
  },
  beforeMount() {
    this.loadReceipts(this.serverParams);
  }
};
</script>

<style scoped>
.card {
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
